<div class="alert w-100 d-flex align-items-center"
  [ngClass]="{'alert-warning': messageType==='warning', 'alert-danger': messageType==='error', 'justify-content-start': !showCloseButton, 'justify-content-between': showCloseButton}"
  role="alert">
  <p class="mb-0 d-flex align-items-center"><img src="assets/images/alerts/alert.svg" height="16" width="16">{{message}}</p>
  <button type="button" class="close border-0 bg-transparent p-0" data-dismiss="alert" *ngIf="showCloseButton" (click)="closeAlert()">
    <img src="assets/images/alerts/alert-cancel.svg" width="16" height="16">
  </button>
</div>
